module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/aosta.6856e2f306b26671f337b744c9adecad.jpg";